import { postOverviewSearch } from "../api/overview.api";

// Normalize to: [{ title, snippet, type, date, link }]
export async function fetchOverviewSearch(queryOrPayload) {
	// Build candidate payloads to avoid 422 due to differing backend expectations
	const baseQuery =
		typeof queryOrPayload === "string"
			? queryOrPayload
			: (queryOrPayload?.query ??
				queryOrPayload?.text ??
				queryOrPayload?.keyword ??
				queryOrPayload?.q ??
				queryOrPayload?.term ??
				"");

	const candidates = [];
	if (typeof queryOrPayload === "object" && queryOrPayload !== null) {
		// Use provided payload first
		candidates.push(queryOrPayload);
	}
	if (baseQuery) {
		candidates.push({ query: baseQuery });
		candidates.push({ query: baseQuery, limit: 10 });
		candidates.push({ query: baseQuery, top_k: 10 });
		candidates.push({ text: baseQuery });
		candidates.push({ keyword: baseQuery });
		candidates.push({ q: baseQuery });
		candidates.push({ term: baseQuery });
	}
	if (candidates.length === 0) {
		candidates.push({}); // last resort
	}

	let raw;
	let lastErr;
	for (const payload of candidates) {
		try {
			raw = await postOverviewSearch(payload);
			lastErr = null;
			break;
		} catch (e) {
			lastErr = e;
			// try next candidate until success
		}
	}
	if (lastErr) throw lastErr;

	const root = raw?.data || raw || {};
	const list =
		root.results ||
		root.items ||
		root.records ||
		(root.data && (root.data.results || root.data.items || root.data.documents)) ||
		root.documents ||
		root.list ||
		[];
	const arr = Array.isArray(list) ? list : [];
	const results = arr.map((x) => ({
		title: x.title || x.name || x.question || x.query || x.text || "",
		snippet:
			x.snippet ||
			x.summary ||
			x.description ||
			x.preview ||
			(typeof x.score === "number" ? `Score: ${x.score.toFixed(4)}` : ""),
		type: x.type || x.category || x.kind || "",
		date: x.date || x.updated_at || x.created_at || x.time || "",
		link: x.url || x.link || x.href || x.path || "",
		score: typeof x.score === "number" ? x.score : undefined,
	}));
	return { results, raw };
}


